import React from 'react';
import { connect } from 'react-redux';

import BreadCrumb from 'jbc-front/components/BreadCrumb';
import { CLIENT_SETTINGS, CLIENT_PAYROLL_RULES_GROUP_LIST } from 'src/constants/EndpointUrls';
import { REDUCER_NAME } from 'src/reducers/clients/unitPrices';
import { setList } from 'src/reducers/common/listReducer';
import ClientUnitPriceTable from './containers/ClientUnitPriceTable';
import { useTranslation } from 'react-i18next';

const ClientUnitPricesList = ({ dispatch, clientUnitPrices, payrollRulesGroup = {}, match }) => {
  const { payrollRulesGroupId } = match.params;
  const { t } = useTranslation();
  dispatch(setList(REDUCER_NAME, { data: clientUnitPrices }));
  return (
    <div>
      <div className="l-main-title-wrap">
        <h1 className="m-title-main">{t('features.ClientUnitPrices.ClientUnitPricesList.Unit_price_list')}</h1>
        <div className="m-title-main-note">{payrollRulesGroup.name}</div>
      </div>
      <div className="l-wrap-xs l-contents-wrap">
        <div className="u-mb20">
          <BreadCrumb>
            <BreadCrumb.Item label={t('features.ClientUnitPrices.ClientUnitPricesList.setting')} path={CLIENT_SETTINGS} />
            <BreadCrumb.Item label={t('features.ClientUnitPrices.ClientUnitPricesList.salary_rule_group_list')} path={CLIENT_PAYROLL_RULES_GROUP_LIST} />
            <BreadCrumb.Item
              label={t('features.ClientUnitPrices.ClientUnitPricesList.provision_deduction_item_list')}
              path={`/clients/payroll_rules_groups/${payrollRulesGroupId}/allowances`}
            />
            <BreadCrumb.Item label={t('features.ClientUnitPrices.ClientUnitPricesList.Unit_price_list')} />
          </BreadCrumb>
        </div>
        <ClientUnitPriceTable payrollRulesGroupId={payrollRulesGroupId} />
      </div>
    </div>
  );
};

export default connect()(ClientUnitPricesList);
